import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatTipoActa(tipoActa) {
  if (tipoActa === 'R') return 'Regular';
  if (tipoActa === 'L') return 'Libre';
  if (tipoActa === 'E') return 'Equivalencia';
  return '';
}

export class UpdateEncabezado extends Component {
  static displayName = UpdateEncabezado.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      errorMessage: '',
      redirect: false,
      id: this.props.match.params.id,
      folio: '',
      libro: '',
      materia: '',
      tipoActa: '',
      fechaExamen: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWActasExamen');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleOnChangeFolio = (e) => {
    this.clearFeedback();
    this.setState({ folio: e.target.value });
  };

  handleOnChangeLibro = (e) => {
    this.clearFeedback();
    this.setState({ libro: e.target.value });
  };

  isOkToSave() {
    return this.state.libro !== '' && this.state.folio !== '';
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;

    if (!this.isOkToSave()) {
      this.setState({ errorMessage: 'Debe ingresar el libro y el folio' });
      return;
    }

    this.postEncabezado();
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/aex/detalle/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel || !data.returnModel.length) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudo cargar el detalle del acta.'
        ),
      });
      return;
    }

    this.setState({
      loadingInitial: false,
      folio: data.returnModel[0].actaExamenFolio ? data.returnModel[0].actaExamenFolio : '',
      libro: data.returnModel[0].actaExamenLibro ? data.returnModel[0].actaExamenLibro : '',
      materia: data.returnModel[0].materiaCarreraNombre.trim() + ' - ' + data.returnModel[0].carreraNombre.trim(),
      fechaExamen: data.returnModel[0].mesaExamenFechaExamen,
      tipoActa: data.returnModel[0].actaExamenTipo,
    });
  }

  async postEncabezado() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/aex/encabezado', {
      method: 'POST',
      body: JSON.stringify({
        ActaExamenFolio: this.state.folio,
        ActaExamenLibro: this.state.libro,
        ActaExamenNacta: this.state.id,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar el encabezado del acta. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-aex" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      errorMessage,
      materia,
      tipoActa,
      fechaExamen,
      libro,
      folio,
    } = this.state;
    const isBusy = loading;

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-aex">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">Actualizar Encabezado de Acta de Examen</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-aex">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">Actualizar Encabezado de Acta de Examen</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-aex">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Actualizar Encabezado de Acta de Examen</h1>
        <p className="md-form-page__subtitle">
          Materia: {materia}
          {' · '}
          Tipo acta: {formatTipoActa(tipoActa)}
          {' · '}
          Fecha examen: {constantClass.formatDisplayDate(fechaExamen)}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando encabezado, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="eae-libro">
                Libro
              </label>
              <input
                id="eae-libro"
                className="md-form-page__input"
                type="text"
                value={libro}
                onChange={this.handleOnChangeLibro}
                disabled={isBusy}
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="eae-folio">
                Folio
              </label>
              <input
                id="eae-folio"
                className="md-form-page__input"
                type="text"
                value={folio}
                onChange={this.handleOnChangeFolio}
                disabled={isBusy}
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
